import { createPromiseAction } from '@adobe/redux-saga-promise';

// Actions for fetching dashboard statistics
export const fetchDashboardStatistics = createPromiseAction('dashboard/fetchStatistics');

// Actions for fetching revenue data
export const fetchRevenueData = createPromiseAction('dashboard/fetchRevenue');
